export const baseURL = "https://agency-api.tikkiearn.com/";
export const key = "u?r(]hEu!HB#0AI(";
